import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ebe51b5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "module-tabs mb-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-package",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-archive-box",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ph ph-storefront",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductsList = _resolveComponent("ProductsList")!
  const _component_ProductStockTab = _resolveComponent("ProductStockTab")!
  const _component_CatalogTab = _resolveComponent("CatalogTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["module-tab", { active: _ctx.activeTab === 'products' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectTab('products')))
        }, [
          _hoisted_4,
          _createTextVNode(" Produtos ")
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["module-tab", { active: _ctx.activeTab === 'stock' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectTab('stock')))
        }, [
          _hoisted_5,
          _createTextVNode(" Estoque ")
        ], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["module-tab", { active: _ctx.activeTab === 'catalog' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTab('catalog')))
        }, [
          _hoisted_6,
          _createTextVNode(" Catálogo ")
        ], 2)
      ]),
      (_ctx.activeTab === 'products')
        ? (_openBlock(), _createBlock(_component_ProductsList, { key: 0 }))
        : (_ctx.activeTab === 'stock')
          ? (_openBlock(), _createBlock(_component_ProductStockTab, { key: 1 }))
          : (_openBlock(), _createBlock(_component_CatalogTab, {
              key: 2,
              ref: "catalogTab"
            }, null, 512))
    ])
  ]))
}